export const APP_TITLES = {
  1: "common.individual",
  2: "common.company",
  3: "common.trust",
};
